/**
 * Styled Components - Created by david on 09/03/18.
 */

import styled from 'styled-components'
import AntdButton from 'antd/lib/button'
import { BLUE, GRAY_DARK, GREEN, GREEN_BRIGHT } from '../../theme/colors'
import Icon from 'antd/lib/icon'

interface DivProps {
  secondary?: boolean
}

export const Container = styled.div`
  display: flex;
`
export const BottomButtons = styled.div`
  bottom: 7%;
  display: flex;
  left: 48%;
  width: 260px;
  align-items: center;
  justify-content: space-between;
  position: absolute;
  transform: translate(-50%, -50%);
`

export const Render = styled.div`
  position: relative;
  width: 85%;

  @media (min-width: 768px) and (max-width: 991px) {
    width: 75%;
  }
`

export const ButtonRight = styled(AntdButton)`
  height: 40px;
`

export const ButtonLocker = styled(AntdButton)`
  height: 40px;
  margin-bottom: 18px;
  color: ${BLUE};
  border: 1px solid ${BLUE};
`

export const ButtonWrapperRight = styled.div`
  bottom: 11.1%;
  margin-bottom: 16px;
  position: absolute;
  right: 26px;

  .ant-btn-primary  {
    background-color: ${BLUE};
    border-color: ${BLUE};
    width: auto;
  }

  .ant-btn-primary:hover {
    background-color: ${BLUE};
    border-color: ${BLUE};
  }
  flex-flow: column;
  display: flex;
`

export const ButtonWrapper = styled.div`
  margin-bottom: 16px;

  .ant-btn-primary  {
    background-color: ${({ secondary }: DivProps) => secondary ? GREEN_BRIGHT : BLUE};
    border-color: ${({ secondary }: DivProps) => secondary ? GREEN_BRIGHT : BLUE};
    width: 138px;
  }
  .ant-btn-primary:hover {
    background-color: ${({ secondary }: DivProps) => secondary ? GREEN_BRIGHT : BLUE};
    border-color: ${({ secondary }: DivProps) => secondary ? GREEN_BRIGHT : BLUE};
  }
`

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 30px;
  width: 15%;

  @media (min-width: 768px) and (max-width: 991px) {
    width: 25%;
  }

  @media (max-width: 1024px) {
    padding: 30px 0px 30px 15px;
  }
`

export const Model = styled.div`
  color: ${GRAY_DARK};
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  user-select: none;
`

export const Row = styled.div`
  align-items: center;
  display: flex;
  margin-bottom: 12px;
`

export const QuickView = styled.img`
  cursor: pointer;
  margin-left: 8px;
`

export const EditContent = styled.div`
  margin: 22px 0 28px -38px;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
`

export const TitleEdit = styled.div`
  text-align: center;
  font-weight: bold;
  font-family: Avenir;
`

export const CheckIcon = styled(Icon)`
  position: absolute;
  top: 22px;
  margin-left: 39px;
  z-index: 2;
  font-size: 18px;
  background: white;
  border-radius: 50%;
  padding: 2px;
  color: ${GREEN};
  box-shadow: -1px 2px 3px 0px #525252;
`

export const LockerIcon = styled.img`
  max-width: 50px;
  filter: drop-shadow(0px 2px 2px gray);
  padding-bottom: 10px;
  margin-bottom: -5px;
  opacity: 0.85;
`

export const TitleCoupon = styled.div`
  text-align: center;
  font-weight: bold;
  font-family: Avenir;
  font-size: 20px;
  max-width: 178px;
  margin: 0 auto;
`

export const CouponBody = styled.div`
  margin: 22px 0 28px -38px;
  text-align: center;
`

export const UseCode = styled.div`
  font-weight: bold;
  font-family: Avenir;
`

export const CouponDiv = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-flow: column;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
`

export const CopyLabel = styled.div`
  position: absolute;
  margin-bottom: -42px;
  font-size: 8.75px;
  margin-left: -38px;
  color: white;
  font-family: Avenir;
`

export const CouponImage = styled.img`
  max-width: 136px;
  margin: 4px;
`

export const CouponLabel = styled.div`
  position: absolute;
  margin-top: 8px;
  margin-right: 40px;
  font-size: 11px;
  color: white;
  font-weight: bold;
  font-family: Avenir;
`

export const ActSoon = styled.div``

export const ExpiryDate = styled.div`
  margin: 0 auto;
  margin-top: 6px;
  color: #868686;
  margin-bottom: -12px;
  background: #f7f7f7;
  width: fit-content;
  padding: 3px 10px;
  border-radius: 25px;
  font-size: 13px;
`

export const Variants = styled.div`
  display: flex;
  flex-flow: column;
  top: 12px;
  z-index: 4;
  right: 26px;
  position: absolute;
  @media (max-width: 1023px) {
    top: 145px;
    left: 18px;
  }
`

export const VariantButton = styled.img`
  width: 50px;
  object-fit: contain;
  max-height: 50px;
  border: 1px solid ${({ secondary }: DivProps) => (secondary ? '#E61737' : '#DCDCDC')};
  border-radius: 3px;
  transition: all 0.25s;
  padding: 5px;
  margin-bottom: 8px;
  background: white;
  &:hover {
    cursor: pointer;
    background: #F1F4F5;
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/DesignCenterPreview/styledComponents.tsx